import ICON_ARROW_LIGHT from '../../../public/static/v4/commonSub/icon-arrow-light.svg';
import ICON_ARROW from '../../../public/static/v4/commonSub/icon-arrow.svg';
import ICON_CIRCLE_ARROW_LIGHT from '../../../public/static/v4/commonSub/icon-more-light.svg';
import ICON_CIRCLE_ARROW from '../../../public/static/v4/commonSub/icon-more.svg';
import Text from '../../common/component/Text';
import useTheme from '../../common/hook/useTheme';
import {ITheme} from '../../common/type';
import {IArrowType} from '../type';

interface IProps {
  text?: string;
  arrowType: IArrowType;
}

export default function SettingItemTextWithArrowV4({text, arrowType}: IProps) {
  const {theme} = useTheme();

  return (
    <div className="flex items-center">
      {text && <Text className="s15-medium-grey08 mr-10">{text}</Text>}
      <img
        className={arrowType === 'onlyArrow' ? 'w-16 h-16' : 'w-20 h-20'}
        src={ICON_MAP[theme][arrowType]}
        alt=""
      />
    </div>
  );
}

const ICON_MAP: {
  [key in ITheme]: {[key in IArrowType]: string};
} = {
  light: {
    circleArrow: ICON_CIRCLE_ARROW_LIGHT,
    onlyArrow: ICON_ARROW_LIGHT,
  },
  dark: {
    circleArrow: ICON_CIRCLE_ARROW,
    onlyArrow: ICON_ARROW,
  },
};
